import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle, GitMerge, Users, PackagePlus, CopyX } from "lucide-react";

export const PreviewStep = ({ counts: c, failedRows, busy, onCommit, onReset }) => (
  <div className="space-y-6 fade-in" data-testid="preview-panel">
    <Card className="shadow-sm border-primary/30">
      <CardContent className="p-8">
        <h2 className="text-2xl font-serif font-semibold">Here's what will happen</h2>
        <p className="mt-3 text-lg leading-relaxed" data-testid="preview-summary">
          This import will create <strong>{c.new_customers} new customer{c.new_customers !== 1 ? "s" : ""}</strong>,
          add <strong>{c.orders_to_existing} order{c.orders_to_existing !== 1 ? "s" : ""}</strong> to existing customers,
          skip <strong>{c.duplicates_skipped} duplicate{c.duplicates_skipped !== 1 ? "s" : ""}</strong>,
          and flag <strong>{c.probable_matches} possible match{c.probable_matches !== 1 ? "es" : ""}</strong> for review.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          {[
            [Users, "New customers", c.new_customers, "preview-new-customers"],
            [PackagePlus, "Orders to add", c.orders_to_add, "preview-orders-to-add"],
            [CopyX, "Duplicates skipped", c.duplicates_skipped, "preview-duplicates"],
            [GitMerge, "Flagged for review", c.probable_matches, "preview-flagged"],
          ].map(([Icon, label, val, tid]) => (
            <div key={label} className="rounded-md bg-secondary/50 p-4" data-testid={tid}>
              <Icon className="h-4 w-4 text-primary" />
              <p className="text-2xl font-serif font-semibold mt-2">{val}</p>
              <p className="text-xs text-muted-foreground">{label}</p>
            </div>
          ))}
        </div>
        {c.rows_failed > 0 && (
          <div className="mt-6 rounded-md border border-destructive/30 bg-destructive/5 p-4" data-testid="preview-failed-rows">
            <p className="flex items-center gap-2 text-sm font-medium text-destructive">
              <AlertTriangle className="h-4 w-4" /> {c.rows_failed} row{c.rows_failed > 1 ? "s" : ""} could not be read and will be skipped:
            </p>
            <ul className="mt-2 text-sm text-muted-foreground space-y-1">
              {failedRows.map((f) => <li key={f.row}>Row {f.row}: {f.reason}</li>)}
              {c.rows_failed > failedRows.length && (
                <li className="italic">…and {c.rows_failed - failedRows.length} more (the full list is in the import's error download).</li>
              )}
            </ul>
          </div>
        )}
        <div className="flex gap-3 mt-8">
          <Button size="lg" onClick={onCommit} disabled={busy || c.orders_to_add === 0} data-testid="confirm-import-btn">
            Yes, import these orders
          </Button>
          <Button size="lg" variant="ghost" onClick={onReset} data-testid="cancel-import-btn">Cancel — don't import anything</Button>
        </div>
      </CardContent>
    </Card>
  </div>
);
